import React, { useEffect, useState, useRef } from 'react'
import './index.scss'
import Check from '../../Utils/Check'
import e from '../../Utils/Event'
import toUploadImg from './upload'
import {riskManagement, getQueryString, formatDate, getIdentifyCodeWithCaptcha, replaceHttpsImg} from '../../Utils/Utils'
import { DatePicker, List } from 'antd-mobile';
import './antd-mobile.css'
import UploadImage from "@kugou/upload-image"

export default function Field(props) {
  let { selfValue, type, byType, setNum, setName, label, placeholder, required,
    options, openSelector, width, height, by, phone, change, disabled, ifModify,
    claimSingerId, sInput, setCredentialHandPic, setCredentialFrontPic, setCardBindPhone, setCheckNumInfo,
    setIfCardBind, tips, hide, showIDCard, authTypeHidden,  setShowAuthFailDialog, 
    setAuthTip, setAuthBtn, openFaceAuth, realAuthTip, showSelectTip, 
    credentialNum, setAuthType, setCredentialType, credentialType,selectType,setSelectType, setCanInput,
    canInput, autoFillRealInfo, setAutoFillRealInfo, params } = props
  
  // const [selfOptions, setSelfOptions] = useState({})
  const [selfDisabled, setSelfDisabled] = useState(false)
  const [authTipShow, setAuthTipShow] = useState(false)
  const [dpShow, setDpShow] = useState(false)
  let timer = null
  let uploadTimer = null

  // 选择器相关
  const [selectItem, setSelectItem] = useState({})

  //倒计时
  const [countNum, setCountNum] = useState(0)

  //图片上传相关
  const [fileImg1, setFileImg1] = useState('')
  const [fileImg2, setFileImg2] = useState('')
  const [fileImg3, setFileImg3] = useState('')
  const [fileImg5, setFileImg5] = useState('')
  const [fileImg6, setFileImg6] = useState('')
  const [fileImg7, setFileImg7] = useState('')

  //简介的文字数
  const [countTextNum, setCountTextNum] = useState(0)

  let fileRef1 = useRef(null)
  let fileRef2 = useRef(null)
  let fileRef3 = useRef(null)
  let fileRef4 = useRef(null)
  let fileRef5 = useRef(null)
  let fileRef6 = useRef(null)
  let fileRef7 = useRef(null)

  const fileRefMap = {
    '1': fileRef1,
    '2': fileRef2,
    '3': fileRef3,
    '4': fileRef4,
    '5': fileRef5,
    '6': fileRef6,
    '7': fileRef7,
  }

  const setImgMap = {
    '1': setFileImg1,
    '2': setFileImg2,
    '3': setFileImg3,
    '5': setFileImg5,
    '6': setFileImg6,
    '7': setFileImg7,
  }

  window.tempScreenshotArr = []
  let [screenshotArr, setScreenshotArr] = useState([])
  const [screenShotUrl, setScreenShotUrl] = useState('')

  /**
  * @description 获取文件对应的url (注意：请求方式请走openapi，这里只是示意)
  * @param {string} fileid cos对应的fileid
  * @return {promise}
  */
  function getUrlByFileid (fileid = '') {
    return new Promise((resolve, reject) => {
        if (!fileid) {
            reject('fileid不存在')
        }
        window.$req('getUploadCosUrl', { fileId: fileid }, { originRes: true }).then((oRes) => {
            let fRes = oRes.data
            if (fRes.errcode === 0) {
                resolve(fRes.data.data)
            } else {
                reject('获取音频播放链接失败')
            }
        }).catch(() => {
            reject('获取音频播放链接失败')
        })
    })
  }

  //初始化站外截图数据
  async function initScreenData() {
    if(window.sessionStorage.getItem('originScreenshotData')) {
      let originScreenshotData = JSON.parse(window.sessionStorage.getItem('originScreenshotData'))
      let tempScreenshotArr = []
      for (let i = 0; i < originScreenshotData.length; i++) {
        var sign_url = (await getUrlByFileid(originScreenshotData[i].fileid)).url
        tempScreenshotArr.push(sign_url)
       
        if(originScreenshotData.length == (i + 1)) {
          setScreenshotArr(tempScreenshotArr);
          let tempSubmitArr = originScreenshotData
          
          window.sessionStorage.setItem('screenshotArr', JSON.stringify(tempScreenshotArr));
          window.sessionStorage.setItem('tempSubmitArr', JSON.stringify(tempSubmitArr));
        }
      }
    } else {
      window.sessionStorage.setItem('screenshotArr', JSON.stringify([]));
      window.sessionStorage.setItem('tempSubmitArr', JSON.stringify([]));
    }
  }
  

  function sometimesDisabled() {
    let inc = ['歌手头像', '歌手名', '歌手身份', '性别', '地区', '流派风格', '简介']
    //针对不能进行身份证号码/名字操作
    let autoL = ['证件号码', '真实姓名']
    if (~window.location.href.indexOf('identity') && disabled && ~inc.indexOf(label)) {
      window.$Msg('机构认证歌手请认领通过后再修改资料')
      return true
    } else if (~autoL.indexOf(label) && !showIDCard) {
      return true
    }

   
    if (byType === 0 && ~autoL.indexOf(label) && (!showSelectTip || !canInput)) {
      window.$Msg('上传身份证后会自动读取' + label)
    }

    return false
  }


  async function sendAuthCode() {
    if (countNum) return;
    if (!phone || !Check.phone(phone)) {
      return window.$Msg('请输入正确的手机号码')
    }
    try {
      const captchaParam = await getIdentifyCodeWithCaptcha();  // 发送验证码前调用这个方法
      console.log(captchaParam, 'captchaParam Field');
      countDown(60)
      window.$req('sendSmsCode', {
        type: by, 
        phone: '+86*' + phone,
        platformAccountId: window.$userInfo.userid,
        platformIdType: 2,
        ticket: captchaParam.ticket,
        randstr: captchaParam.randstr
      }).then(res => {
        window.$Msg('发送成功')
      }).catch(rese => {
        console.log(rese, 'sendAuthCode Field catch');
        window.$Msg(rese && rese.message ? rese.message : '发送失败，请稍后刷新重试~');
      })
    } catch (error) {
      console.log(error, 'sendAuthCode Field error');
    }
  }

  function countDown(num) {
    setCountNum(num)
    if (!num) return;
    timer = setTimeout(() => {
      num--
      countDown(num)
    }, 1000)
  }

  function toSelector() {
    if (sometimesDisabled()) return;
    if (disabled) return;
    // if (selfDisabled) return;
    let title = props.title || '选择' + label
    //身份证和户口簿只能选中国大陆
    if((credentialType == 0 || credentialType == 4) && props.dictName == 'country') {
      options = options.slice(0, 1)
    }
    openSelector({
      title, options, value: selectItem.value, input: label == '就读院校', change: item => {
        if (label === '证件类型') {
          setNum('')
          setName('')
          if (~item.label.indexOf('身份证')) {
            setCredentialHandPic('')
            setCredentialFrontPic('')
            // setNum('')
            // setName('')
          }
        }
        if( label == '认证方式' ){
          setCredentialHandPic('')
          setCredentialFrontPic('')
          setNum('')
          setName('')
        }
        setSelectItem(item)
        change(item.value)
        //如果选择内地身份证，则国籍只能选中国
        // if (label==='证件类型' && item.value===0){
        //   setSelfOptions
        // }
      }
    })
  }

  function resetLoadText() {
    if (window.$endupload) {
      window.$endupload()
      window.$endupload = null
    }
  }

  function chooseImg(e, count) {
    e.stopPropagation();
    console.log('credentialType',credentialType)
    if(credentialType == 4 && ifAdult()) {
      window.$Msg('请选择身份证认证')
      return
    }
    if (type === 'portrait') {
      if (sometimesDisabled()) return;
      if (disabled /* || !!claimSingerId */) return;
    }
    if (byType === '') {
      return window.$Msg('请先选择证件类型')
    }

    if (window.$endupload) return;

    if (type === 'portrait') {
      imgUpload(change)
      /* if(window.LC.isIOS){
        clientPortraitUpload()
      }else{
        //安卓防止重复打开
        uploadTimer && clearTimeout(uploadTimer)
        uploadTimer = setTimeout(() => {
          clientPortraitUpload()
        }, 300);
      } */
      return;
    }

    let picFile = fileRefMap[count].current
    if(window.LC.isIOS){
      picFile.click()
    }else{
      //安卓防止重复打开
      uploadTimer && clearTimeout(uploadTimer)
      uploadTimer = setTimeout(() => {
        picFile.click()
      }, 300);
    }

    picFile.onchange = function () {
      let file = this.files[0]
      if (!file) return;
      window.$endupload = window.$Text('上传中···')

      if (type === 'portrait' || (type === 'idcard' && count === 1)) {
        let fileReader = new FileReader()
        fileReader.onload = function () {
          let result = this.result
          let img = new Image()
          img.src = result
          //读取图片信息，
          img.onload = function () {
            let imgWidth = img.width
            let imgHeight = img.height
            //身份证正面上传
            if (type === 'idcard' && byType === 0) {
              //大于500k压缩一下
              if (file.size > 50 * 1024) {
                zipImg(img, 1000, 0.25, base64 => {
                  idcardOcr(base64)
                })
              } else {
                idcardOcr(result)
              }
              uploadImg(file, count)
              return;
            }
            //头像上传
            if (type === 'portrait' && (imgWidth < width || imgHeight < height)) {
              resetLoadText()
              return window.$Msg(`请上传大于500x500的图片`);
            }
            // if (type === 'portrait' && (imgWidth != imgHeight)) {
            //   resetLoadText()
            //   return window.$Msg(`请上传正方形图片`);
            // }
            uploadImg(file, count)
          }
          img.onerror = function () {
            resetLoadText()
            return window.$Msg(`上传失败，请稍后重试`);
          }
        }
        fileReader.onerror = function () {
          resetLoadText()
          return window.$Msg(`上传失败，请稍后重试`);
        }
        fileReader.readAsDataURL(file)
      } else if (type === 'screenshot') {
        window.loopTime = 0; 
        window.screenshotArrLength = this.files.length
        for(let i = 0; i < this.files.length; i++) {
          window.$endupload = window.$Text('上传中···')
          uploadImg(this.files[i])
        }
      } else {
        uploadImg(file, count)
      }

    }
  }

  function imgUpload(change){
    window.uploadEle = null;
    window.uploadEle = new UploadImage({
      ratio: 1, //裁剪宽高比
      imgCropper: true, //是否使用裁剪功能，默认为false
      form: "image/jpeg", //输出图片格式，'image/jpeg'、'image/png'，默认image/jpeg
      accept: "image/png,image/jpeg,image/jpg",
      cwidth: 1500, //裁剪输出尺寸
      cheight: 1500, //裁剪输出尺寸
      fileSizeLimit: 10,
      fileSizeLimitTip: "请选择小于10MB的图片~",
      cropperOptions: {
        viewMode: 1
      },
      openLoading: ()=>{
        e.emit('loading', true)
      },
      hideLoading: ()=>{
        e.emit('loading', false)
      },
      log: true,
      //上传成功回调
      result: urlArr => {
        window.uploadingFlag = false
        //返回对象数组
        if(urlArr[0].status == 1){
          change(replaceHttpsImg(urlArr[0].url))
        }else{
          window.$Msg('上传失败，请重新选择重试~')
        }
      },
      //失败回调
      fail: () => {
        window.uploadingFlag = false
        console.log("fail");
        window.$Msg('上传失败，请重新选择重试~')
      }
    });
    window.uploadingFlag = true
    window.uploadEle.upload()
  }


  function clientPortraitUpload() {
    window.LC.KgWebMobileCall("KgWebMobileCall.returnAuthMeet", function (res) {
      res = typeof res === 'string' ? JSON.parse(res) : res
      if (~~res.status === 1) {
        change(replaceHttpsImg(res.url))
      } else {
        return window.$Msg(`上传失败，请稍后重试`);
      }
    });
    window.LC.mobileCall(266, { type: 2 })
  }

  function getType(fileName) {
    let index = fileName.lastIndexOf('.')
    return fileName.slice(index + 1).toLowerCase()
  }


  function uploadImg(file, count, normal) {
    let filetype = getType(file.name)
    // if (filetype === '.jpeg') {
    //   filetype = '.jpg'
    // }

    toUploadImg({
      image: file,
      imageType: filetype,
      storeType: normal ? 2 : 1,
      success(res) {
        let { url } = res
        if(type !== 'screenshot') setImgMap[count](url)
        resetLoadText()
        //change回归
        if (type === 'portrait') {
          change(url)
        } else if (type === 'idcard') {
          change[count - 1](url)
        } else if (type === 'screenshot') {
          if (JSON.parse(window.sessionStorage.getItem('screenshotArr')) && JSON.parse(window.sessionStorage.getItem('screenshotArr')).length >= 5) {
            window.$Msg(`最多能上传5张`);
          } else if(file.size > 10*1024*1024){
            window.$Msg(`截图大小不能超过10M`);
          } else {
            window.loopTime++;
            let tempScreenshotArr = JSON.parse(window.sessionStorage.getItem('screenshotArr')) || [];
            let tempSubmitArr = JSON.parse(window.sessionStorage.getItem('tempSubmitArr')) || [];
            tempScreenshotArr.push(url);
            tempSubmitArr.push({
              id: '',
              fileName: url.slice(url.indexOf('cos_'), url.indexOf('?')).split('.')[0],
              fileType: file.type,
              fileSize: file.size,
              fileid: url.slice(url.indexOf('cos_'), url.indexOf('?'))
            });
            window.sessionStorage.setItem('screenshotArr', JSON.stringify(tempScreenshotArr));
            window.sessionStorage.setItem('tempSubmitArr', JSON.stringify(tempSubmitArr));
            if( tempScreenshotArr.length == 5 || window.loopTime == window.screenshotArrLength) {
              setScreenshotArr(tempScreenshotArr);
            }
          }
        } else if (type === 'studentID') {
          //config里的change对应的方法
          //change: [ops['setCardCover'], ops['setCardContentPage'], ops['setCardRegisterPage']]
          let countMap = {
            5: 0,
            6: 1,
            7: 2
          }
          change[countMap[count]](url)
        }
      },
      error(msg) {
        // window.$Msg(`您提交的证件照片过大，请压缩至5M以下再重新上传`);
        window.$Msg(`上传失败，请稍后重试`);
        setTimeout(() => {
          resetLoadText()
        }, 2000)
      },
      progress(percent) {
        // console.log(percent)
      }
    })
  }

  //压缩图片
  function zipImg(img, zipWidth, quality, callback) {
    let w = img.width
    let h = img.height
    let scale = w / h
    let zipHeight = zipWidth / scale
    let canvas = document.createElement('canvas')
    canvas.width = zipWidth
    canvas.height = zipHeight
    let ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0, w, h, 0, 0, zipWidth, zipHeight)
    let base64 = canvas.toDataURL('image/jpeg', quality || 0.7)
    callback(base64)
  }

  function setValue(e) {
    let value = e.target.value
    if(label === '就读院校'){
      let iconRule1 = /[`~!@#$%^&*()_\-+=<>?:"{}|,\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
      let iconRule2 = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig
      if (iconRule1.test(value) || iconRule2.test(value)) {
        window.$Msg('请不要输入特殊字符')
        value = value.replace( new RegExp( iconRule1 ), '' );
        value = value.replace( new RegExp( iconRule2 ), '' );
      }

      if(value.length > 60){
        value = value.slice(0,60)//限制字数
        window.$Msg('最多输入60个字哦~')
      }
    }
    
    change(value)
  }

  //已实名自动填写身份证信息，用户点击输入框清空
  function focusCheck(){
    window.inputFocusNow = label;
    if( label == '证件号码' && credentialNum && ~credentialNum.indexOf('*') && autoFillRealInfo ){
      setNum('')
      setAutoFillRealInfo(false)
    }
  }

  // 敏感词校验
  function checkSensitive() {
    //console.log('label', label)
    if (!window.LC.isInClient() && /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent)) {
      setTimeout(() => {
        window.document.activeElement.scrollIntoViewIfNeeded(true);
      }, 100)
    }

    if (label === '歌手名' && selfValue) {
      window.$req('checkSingerName', { name: selfValue }).then(res => {
        let data = res.data
        if (!data.result) {
          change('')
          window.$Msg(label + ':' + data.resultInfo)
        }
      })
    }

    if (label === '邮箱') {
      return checkMail()
    }

    if (label === '证件号码') {
      //身份证号不可填，所以不会触发到blur这里
      checkNum(selfValue);
      return
    }

    if (!selfValue) return;
    window.$req('checkSensitive', { word: selfValue }).then(res => {
      let data = res.data
      if (!data.result) {
        window.$Msg(label + ':' + data.resultInfo)
      }
    })
  }

  //邮箱校验
  function checkMail() {
    // window.$req('checkMail', { mail: selfValue }).then(res => {
    //   let check = res.data.result
    //   if (!check) {
    //     window.$Msg('邮箱格式错误')
    //   }
    // })
  }

  //证件号检验
  function checkNum(value) {
    if (byType === '') return;
    if(byType === 4) {
      console.log('length', selfValue.length)
      if(selfValue.length == 18) {
        const birthYear = selfValue.substring(6,10);
        const nowYear = new Date().getFullYear()
        if(ifAdult()) {
          //收起键盘
          // setTimeout(() => {
          //   console.log('456')
          //   document.getElementById('zhengjian').focus()
          //   document.getElementById('zhengjian').blur()
          // }, 0)
          
          setShowAuthFailDialog(true)
          setAuthTip('户口簿仅适用于未满18岁的用户，您已满18岁，请使用身份证进行实名认证');
          setAuthBtn({
            1: false,
            2: false,
            3: false,
            4: true
          })
        }
      } else {
        window.$Msg('请输入完整身份证')
        return
      }
    }
    value = byType === 0 ? value : selfValue
    if (!value) return;
    setCardBindPhone('')
    setIfCardBind(false)
    if(getQueryString('debug')&&getQueryString('noidcheck')){ return;}//debug 不检测身份证是否占用
    window.$req('checkNum', { idcardNum: value, type: byType }).then(res => {
      let check = res.data.result
      if (!check) {
        // window.$Msg(res.data.resultInfo)
        if (byType === 0) {
          if(showIDCard) {
            setNum('')
            setName('')
          } else {
            change('')
          }
        }

        let data = res.data.bindPhone
        setCardBindPhone(data)
        setCheckNumInfo(res.data.resultInfo)
        setIfCardBind(true)
      }
    }).catch(rese => {
      // let code = rese.code
      // if (code === 40088) {
      //   let data = rese.data.bindPhone
      // }
    })
  }

  //身份征信检测
  function checkCredit(id, name) {
    // if (byName === '' || !value) return;
    window.$req('checkCredit', { id, name }).then(res => {
      let check = res.data.result
      if (!check) {
        window.$Msg(res.data.resultInfo)
        setNum('')
        setName('')
      } else {
        checkNum(id)
      }
    })
  }

  //识别身份证信息
  function idcardOcr(image) {
    e.emit('loading', { loading: true, text: '识别中' })
    image = image.replace(/^data:image\/[a-z]+;base64,/, "")
    if (!image) return;
    window.$req('idcardManSideOcr', { image }).then(res => {
      e.emit('loading', false)
      let data = res.data
      if (data) {
        setNum(data.id)
        setName(data.name)
        checkCredit(data.id, data.name)
        setCanInput(false)
      }
    }).catch(resE => {
      e.emit('loading', false)
      if (resE.message) {
        window.$Msg(resE.message)
        setNum('')
        setName('')
      }
    })
  }

  useEffect(() => {
    type === 'screenshot' && initScreenData()
  }, [])

  useEffect(() => {
    if (type === 'select') {
      // console.log('now',props)
      let item = options.find(ele => ele.value === selfValue) || {}
      setSelectItem(item)
    } else if (type === 'portrait') {
      setFileImg1(selfValue)
    } else if (type === 'idcard') {
      setFileImg1(selfValue[0])
      setFileImg2(selfValue[1])
      setFileImg3(selfValue[2])
    } else if (type === 'studentID') {
      setFileImg5(selfValue[0])
      setFileImg6(selfValue[1])
      setFileImg7(selfValue[2])
    } else if (label === '手机') {
      if (window.$userStatus && window.$userStatus.hasOwnProperty('users')) {
        setSelfDisabled(true)
        change(window.$userStatus.phone)
      }
    }
    return () => {
      clearTimeout(timer)
    }
  }, [type, options, selfValue, timer])

  function delScreenshotArr(index) {
    var arr = JSON.parse(window.sessionStorage.getItem('screenshotArr'))
    var arr_1 = JSON.parse(window.sessionStorage.getItem('tempSubmitArr'))
    arr.splice(index, 1)
    arr_1.splice(index, 1)
    window.sessionStorage.setItem('screenshotArr', JSON.stringify(arr))
    window.sessionStorage.setItem('tempSubmitArr', JSON.stringify(arr_1))
    setScreenshotArr(arr);
  }

  function authTypeTipClass() {
    if(!showSelectTip) return ' hidden'
    else return ' select-tip'
  }

  function ifAdult() {
    if(credentialNum && credentialNum.length == 18) {
      const birthYear = credentialNum.substring(6,10);
      const birthMonthDate = credentialNum.substring(10,14);
      const nowYear = new Date().getFullYear();
      const nowMonth = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
      const nowDate = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
      const nowMonthDate = String(nowMonth) + String(nowDate)
      //console.log('nowMonthDate',nowMonthDate)
      //console.log('birthMonthDate',birthMonthDate)
      if(nowYear - birthYear > 18) return true
      else if(nowYear - birthYear == 18) {
        if(Number(nowMonthDate) - Number(birthMonthDate) > 0) return true
        else return false
      } else return false
    } else if (credentialType != 4) {
      return true
    } else return false
  }
  function handlePlaceHolder(placeholder) {
    if(credentialType == 4 && label == '证件号码') return '请输入个人页公民身份证件编号'
    if(credentialType == 4 && label == '真实姓名') return '请输入个人页姓名'
    return placeholder
  }

  function errImg(e){
    e.target.src = 'https://webimg.kgimg.com/8afad1a19aededec941e4938367aa4a3.png'
  }

  /* if(label === '证件号码' || label === '真实姓名'){
    console.log(label, byType === 0 && ((showIDCard && !showSelectTip) || !canInput));
    console.log('byType ', byType, byType===0, byType ==0);
    console.log('showIDCard ', showIDCard);
    console.log('!showSelectTip ', !showSelectTip);
    console.log('!canInput ', !canInput);
  } */

  return ((type !== 'authcode' || (!ifModify && !(window.$userStatus && window.$userStatus.hasOwnProperty('users')))) &&  !hide && <div className={"Field" + 
    ({ 'textarea': ' area', 
      'idcard': ` idcard ${byType !=0 || (showIDCard && byType == 0) ? '' : 'hidden'}`,
      'studentID': ' studentID',
      'screenshot': ' screenshot' }[type] || '') + 
    ((type === 'screenshot' && !claimSingerId) ? ' hidden' : '') + 
    (((label === '认证方式' || label === '实名认证') && authTypeHidden) ? ' hidden' : '') + 
    ((type === 'authTypeTip') ? authTypeTipClass() : '') + 
    (type === 'select' && label == '证件类型' ? ' new-height' : '')} onClick={sometimesDisabled}>

    {!~['textarea', 'idcard'].indexOf(type) && <span className="label">{`${label=='证件号码' && (byType === 0 || byType === 4) ? '身份证号码':label}`}{required && <i className="red">*</i>}</span>}
    
    {label === '邀请码' && <span className="tipsIcon invitecode" onClick={() => tips(true)}></span>}

    {type === 'text' && <input className="text" 
      disabled={selfDisabled || disabled || !!claimSingerId || 
      (label === '手机' && ifModify) || 
      (label === '证件号码' && byType === 0 && ((showIDCard && !showSelectTip) || !canInput)) || 
      (label === '真实姓名' && byType === 0 && ((showIDCard && !showSelectTip) || !canInput))} 
      placeholder={handlePlaceHolder(placeholder)} value={selfValue || ''} onChange={setValue} onBlur={checkSensitive} onFocus={focusCheck}></input>}
      
    {type === 'selectTime' && <div className={"info date-select" + (disabled ? ' disabled' : '')}>
      <DatePicker
        mode="date"
        title="毕业时间"
        visible={dpShow}
        value={selfValue && new Date(selfValue)}
        onOk={date => {
          change(formatDate(date))
          setDpShow(false)
          console.log(date, formatDate(date));
        }}
        onDismiss={()=>{
          setDpShow(false)
        }}
        minDate={new Date(2000, 1, 1, 0, 0, 0)}
        maxDate={new Date(2040, 11, 31, 0, 0, 0)}
      ></DatePicker>
      <List.Item arrow="horizontal" extra={selfValue} onClick={()=>{
        setDpShow(true)
      }}></List.Item>
    </div>}
    
    {type === 'select' && <div className={"info" + (disabled ? ' disabled' : '')} onClick={toSelector}>{selectItem.label == '上传手持身份证照片、身份证正反面' ?　'上传身份证':selectItem.label}</div>}
    {type === 'select' && label == '证件类型' && <span className='cre-type-tip'>18周岁以下可选择户口簿认证</span>}
    {/* {label === '认证方式' && authTipShow && <div className={"auth-tip"}>您可以选择其它认证方式</div>} */}
    {label === '证件类型' && ifAdult() && credentialType == 4 && <div className={"auth-tip"} style={{'color':'red'}}>*请选择身份证认证</div>}
    {type === 'textarea' && <div className="textarea">
      <p className="areaTitle">{label}{required && <i className="red">*</i>}</p>
      <textarea className="intro-text" placeholder={placeholder} rows="5" disabled={disabled} value={selfValue || ''} onChange={e => {
        setCountTextNum(e.target.value.length)
        setValue(e)
        if (!e.target.value) {
          let target = e.target.style
          let color = target.color
          if (!color || color === 'inherit') {
            target.color = '#000000'
          } else {
            target.color = 'inherit'
          }
        }
      }} onBlur={checkSensitive} ></textarea>
      {label === '简介' && <section className="countNum">{countTextNum}/2000</section>}
    </div>}
    {type === 'authBtn' && <div className={`info ${realAuthTip.type == 'error' ? 'error' : ''}`} onClick={() => {openFaceAuth()}}>{realAuthTip.text}</div>}
    {type === 'authTypeTip' && <div>
      <div className="tip">{(showSelectTip && ifAdult()) ? '您可以选择上传身份证' : '您可以选择以下方式上传'}</div>
      {
        (showSelectTip && ifAdult()) ? setAuthType(1) : <div className="choose">
          <div className={`no-choose ${selectType == 0 ? 'choosed' : ''}`} onClick={() => {setAuthType(1);setCredentialType(0);setSelectType(0)}}>上传身份证</div>
          <div className={`no-choose ${selectType == 1 ? 'choosed' : ''}`} onClick={() => {setAuthType(2);setCredentialType(4);setSelectType(1)}}>上传户口簿</div>
        </div>
      }
    </div>}
    {type === 'portrait' && <div className={"portrait info" + (fileImg1 ? ' uploaded' : '')} onClick={e => chooseImg(e, '1')}>
      {!!fileImg1 && <div className="img" style={{ backgroundImage: 'url(' + fileImg1 + ')' }} ></div>}
      <input ref={fileRef1} type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
    </div>}
    {type === 'screenshot' &&
      <div className="screenshot">
        <div className="upload-screenshot" onClick={e =>chooseImg(e, '4')}>上传图片</div>
        <input ref={fileRef4} multiple type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
        {screenshotArr.map((item, index) => {
          return <div className="each" key={index}>
              <span className="name" onClick={()=> { console.log('img-url',item); setScreenShotUrl(item)}}>图片{index + 1}</span>
              <span className="del" onClick={() => { delScreenshotArr(index) }}>删除</span>
            </div>
        })}
        {screenShotUrl && 
          <div className="screenshot-c" onClick={()=> {setScreenShotUrl('')}}>
            <img src={screenShotUrl}/>
          </div>
        }
        <div className="tip">
          <p>1.如你已入驻其它音乐平台，上传该平台的个人主页截图（最多5张），将在36小时内审核完毕；</p>
          <p>2.图片需包含：歌手名、头像、平台logo信息，必须为jpg、png格式，每张大小&lt;10M</p>
        </div>
      </div>
    }
    {type === 'authcode' && !ifModify && !(window.$userStatus && window.$userStatus.hasOwnProperty('users')) && <div className="authcode">
      <input className="code" placeholder={placeholder} onChange={setValue}></input>
      {/* <section className="sendBtn" onClick={sendAuthCode}>发送验证码</section> */}
      <section className={"sendBtn" + (countNum ? ' wait' : '')} onClick={sendAuthCode}>{countNum ? (countNum + 's') : '发送验证码'}</section>
    </div>}
    {type === 'idcard' && <div className="idcarditem" style={credentialType == 4 && ifAdult() ? {'opacity': '0.3'} : {}}>
      <p className="areaTitle">{label}{required && <i className="red">*</i>}
        <span style={{"color":"#0090ff","fontSize":"0.24rem","position": "absolute","right": "0.2rem"}} /* className="tipsIcon"  */onClick={() => tips(true)}>查看示例</span>
      </p>
      <p className="tips">{placeholder}</p>
      <div className="itemContainer">
        <div className={`item hand ${credentialType == 4 ? 'hukoubu1' : ''}`} onClick={e => chooseImg(e, 3)}>
          {fileImg3 && <div className="imgContainer"><img alt="" src={fileImg3} onError={errImg}/></div>}
          <input ref={fileRef3} type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
          <p className="imgTips">{byType === 4 ? '户口簿首页' : '上传手持人像面'}</p>
        </div>
        <div className={`item front ${credentialType == 4 ? 'hukoubu2' : ''}`} onClick={e => chooseImg(e, 1)}>
          {fileImg1 && <div className="imgContainer"><img alt="" src={fileImg1} onError={errImg}/></div>}
          <input ref={fileRef1} type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
          <p className="imgTips">{byType === 4 ? '个人页' : '上传人像面'}</p>
        </div>
        {byType === 0 && <div className="item back" onClick={e => chooseImg(e, 2)}>
          {fileImg2 && <div className="imgContainer"><img alt="" src={fileImg2} onError={errImg}/></div>}
          <input ref={fileRef2} type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
          <p className="imgTips">上传国徽面</p>
        </div>}
      </div>
    </div>}
    {type === 'studentID' && <div className="idcarditem schoolInfo">
      <p className="stTip">上传学生证后才可认证校园音乐人</p>
      <div className="itemContainer">
        <div className={`item`} onClick={e => chooseImg(e, 5)}>
          {fileImg5 && <div className="imgContainer"><img alt="" src={fileImg5} onError={errImg}/></div>}
          <input ref={fileRef5} type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
          <p className="imgTips">学生证正面<br/><span>(含学校名称)</span></p>
        </div>
        <div className={`item`} onClick={e => chooseImg(e, 6)}>
          {fileImg6 && <div className="imgContainer"><img alt="" src={fileImg6} onError={errImg}/></div>}
          <input ref={fileRef6} type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
          <p className="imgTips">信息页<br/><span>(含照片和个人信息)</span></p>
        </div>
        <div className="item" onClick={e => chooseImg(e, 7)}>
          {fileImg7 && <div className="imgContainer"><img alt="" src={fileImg7} onError={errImg}/></div>}
          <input ref={fileRef7} type="file" accept="image/*" onClick={e => e.stopPropagation()}></input>
          <p className="imgTips">注册登记页<br/><span>(含每学期注册信息)</span></p>
        </div>
      </div>
      <div className="school-tip">
        <p>1.证件图片中有效证件占整图比例不得低于80%，拍摄时不要手持，背景尽量选择白色，避免反光、遮挡等情况。</p>
        <p>2.图片必须为jpg、png格式，且大小小于10M。</p>
      </div>
    </div>}
  </div>)
}